module.exports = __webpack_public_path__ + "static/media/vegas-7.6caf3072.jpg";